import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, Optional, Output } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

import { TranslocoPipe } from '@jsverse/transloco';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { UiIconsList, UiIconsModule } from 'ui-icons';

type Value = unknown;

@Component({
  selector: 'ui-platform-switch',
  templateUrl: './switch.component.html',
  styleUrl: './switch.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgIf,
    FormsModule,
    NzSwitchModule,
    NzToolTipModule,
    UiIconsModule,
    TranslocoPipe
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UiPlatformSwitchComponent),
      multi: true
    }
  ]
})
export class UiPlatformSwitchComponent implements ControlValueAccessor {
  @Input() label = '';
  @Input() disabled = false;
  @Input() icon!: UiIconsList;
  @Input() tooltip?: string;
  @Input() reverse = false;

  @Output() switchChanged = new EventEmitter();

  internalValue: Value = null;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  syncExternalValue: (value: Value) => void = () => {};
  syncExternalTouched: () => void = () => {};

  onModelChange(value: Value) {
    this.syncExternalValue(value);
    this.syncExternalTouched();
    this.switchChanged.emit(value);
  }

  writeValue(value: Value) {
    this.internalValue = value;
    this.changeDetectorRef.detectChanges();
  }

  registerOnChange(fn: (value: Value) => void) {
    this.syncExternalValue = (value: Value) => {
      fn(value);
    };
  }

  registerOnTouched(fn: () => void) {
    this.syncExternalTouched = () => {
      fn();
    };
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
    this.changeDetectorRef.detectChanges();
  }
}
